class AnchorScroll {
    constructor(){
        document.querySelectorAll('a[href*="#"]')?.forEach(function(anchor){
            anchor.addEventListener('click', function(e){
                let href = anchor.getAttribute('href');
                if (href === "#"){return;}
                let target = document.querySelector(href);
                
                if (target){
                    let offsetTop = getOffsetTop(target);
                    window.scrollTo({
                        top: offsetTop,
                        behavior: 'smooth'
                    })
                }
                e.preventDefault();
                return false;
            });
        })
        function getOffsetTop(element) {
            const rect = element.getBoundingClientRect();
            let header = document.querySelector('.header');
            let headerValue = getComputedStyle(document.body)
                .getPropertyValue('--header-sticky-menu')
                .trim();
            if (headerValue){
                let headerHeight = parseInt(headerValue, 10);
    
                return rect.top + window.scrollY - headerHeight;
            }

            if (header){
                return rect.top + window.scrollY - header.clientHeight;
            }
            return rect.top + window.scrollY;
        }
    }

}

export default AnchorScroll;